module.exports = __webpack_public_path__ + "static/media/canaldemiromain.a38ca9cb.woff2";